import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class MidMarketModal implements AnalyticsObject {
  name: string
  properties: AnalyticsProperties
  constructor() {
    this.name = 'Mid-market Modal'
    this.properties = {}
  }
}
